/**
 * Application state keys
 */
export const State = {
    /**
     * State key indicating whether the pointer is captured by an interaction.
     */
    PointerCaptured: 'pointer-captured',
    /**
     * State key indicating whether a dialog is opened.
     */
    DialogOpened: 'dialog-opened',
};
